<template>
  <svg
    width="31"
    height="30"
    viewBox="0 0 31 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_309_6446)">
      <path
        d="M4.25 1.875C2.18164 1.875 0.5 3.55664 0.5 5.625C0.5 7.69336 2.18164 9.375 4.25 9.375H4.30859C4.52539 14.584 8.82031 18.75 14.0938 18.75H17.375V7.5H4.25C3.21289 7.5 2.375 6.66211 2.375 5.625C2.375 4.58789 3.21289 3.75 4.25 3.75H27.6875C28.2031 3.75 28.625 3.32812 28.625 2.8125C28.625 2.29688 28.2031 1.875 27.6875 1.875H4.25ZM13.625 26.7188C13.625 27.498 14.252 28.125 15.0312 28.125H19.25V23.8945L15.4941 22.582C14.7617 22.3242 13.959 22.7109 13.7012 23.4434C13.4434 24.1758 13.8301 24.9785 14.5625 25.2363L14.8262 25.3301C14.1523 25.4238 13.625 26.0098 13.625 26.7188ZM21.125 28.084C23.2578 27.8906 25.1973 27.0527 26.7559 25.7637L21.6875 23.7363C21.5117 23.8418 21.3242 23.9238 21.125 23.9883V28.084ZM28.1914 24.3164C29.6328 22.541 30.5 20.2793 30.5 17.8125C30.5 17.0918 30.4238 16.3887 30.2832 15.709L22.9297 20.8066C22.9766 21.0059 23 21.2168 23 21.4277C23 21.6973 22.959 21.9551 22.8887 22.1953L28.1914 24.3164ZM20.1875 7.5H19.25V18.75H20.3223C20.9023 18.75 21.4414 18.9375 21.8809 19.248L29.7031 13.834C28.1445 10.1133 24.4707 7.5 20.1875 7.5ZM10.3438 11.25C10.3438 10.877 10.4919 10.5194 10.7556 10.2556C11.0194 9.99191 11.377 9.84375 11.75 9.84375C12.123 9.84375 12.4806 9.99191 12.7444 10.2556C13.0081 10.5194 13.1562 10.877 13.1562 11.25C13.1562 11.623 13.0081 11.9806 12.7444 12.2444C12.4806 12.5081 12.123 12.6562 11.75 12.6562C11.377 12.6562 11.0194 12.5081 10.7556 12.2444C10.4919 11.9806 10.3438 11.623 10.3438 11.25Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_309_6446">
        <rect
          width="30"
          height="30"
          fill="currentColor"
          transform="translate(0.5)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Shrimp',
} as DefineComponent
</script>
